/// <amd-module name="Feed/Legacy/Protocols/Upstream/UpstreamClientTool" />
import * as React from "react";

import { IVssPageContext } from "VSS/Platform/Context";

import { IPackageProtocolClient } from "Feed/Legacy/Protocols/Common/IPackageProtocol";
import { UpstreamConnectToFeedPanel } from "Feed/Legacy/Protocols/Upstream/UpstreamConnectToFeedPanel";
import { HubAction } from "Feed/Legacy/Types/IHubState";
import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";

import { FeedView } from "Feed/Common/Contracts/Feed";
import * as PackageResources from "Feed/Common/Resources";
import { BowtieIconProps } from "Feed/Common/Utils/Icons";

export class UpstreamClientTool implements IPackageProtocolClient {
    public readonly name = PackageResources.Upstream_this_feed;
    public readonly vssIconProps = new BowtieIconProps("brand-visualstudio");

    private pageContext: IVssPageContext;

    constructor(pageContext: IVssPageContext) {
        this.pageContext = pageContext;
    }

    public getConnectPanel(feed: Feed, feedViews: FeedView[], hubAction: HubAction): JSX.Element {
        return (
            <UpstreamConnectToFeedPanel
                pageContext={this.pageContext}
                feed={feed}
                feedViews={feedViews}
                hubAction={hubAction}
            />
        );
    }
}
